"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-eight/sections/supportSection.tsx */

import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type SupportSection46sItem = {
    key: Key | null | undefined;
    /** Detected variants: "isax isax-profile-tick5" | "isax isax-ticket-star5" | "isax isax-calendar-15" */
    className: string;
    /** Detected variants: "Expert Professionals and World Class Facilities" | "Specialty Eyecare treatment for all" | "Online Appointment and Excellent Treatment" */
    h30Text: ReactNode;
    /** Detected variants: "Find Doctors" | "Book an Appointment" | "View all Services" */
    link0Text: ReactNode;
    /** Detected variants: "col-xl-4 col-lg-6" */
    divClassName?: string;
    /** Detected variants: "journey-item-eight" */
    div0ClassName?: string;
    /** Detected variants: "journey-icon" */
    div0ClassName2?: string;
    /** Detected variants: "journey-content" */
    div1ClassName?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
    /** Detected variants: "all_routes.doctorAppointments" */
    href?: string;
    /** Detected variants: "isax isax-arrow-right-3" */
    i0ClassName?: string;
};
export type HomeEightSupportSectionGeneratedProps = {
    divDiv0Div1H30H3Props?: Partial<ComponentProps<"h3">> | ((item: SupportSection46sItem) => Partial<ComponentProps<"h3">>);
    divDiv0Div1Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: SupportSection46sItem) => Partial<ComponentProps<typeof SmartLink>>);
    /** Default: "1s" */
    sectionDataWowDuration?: string;
    sectionDiv0Div0ClassName?: string;
    supportSection46s: SupportSection46sItem[];
    supportSection46sItemWrapper?: (item: SupportSection46sItem, content: ReactNode) => ReactNode;
    supportSection46sRenderer?: (defaultNode: ReactNode) => ReactNode;
    supportSection46sLinkVisible?: boolean;
    supportSection46sLinkRenderer?: (item: SupportSection46sItem, defaultNode: ReactNode) => ReactNode;
    supportSection46sH3Visible?: boolean;
    supportSection46sH3Renderer?: (item: SupportSection46sItem, defaultNode: ReactNode) => ReactNode;
    supportSection46sLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: SupportSection46sItem) => Partial<ComponentProps<typeof SmartLink>>);
    supportSection46sH3Props?: Partial<ComponentProps<"h3">> | ((item: SupportSection46sItem) => Partial<ComponentProps<"h3">>);
};

const HomeEightSupportSectionGenerated: FC<HomeEightSupportSectionGeneratedProps> = ({
    sectionDataWowDuration = "1s",
    divDiv0Div1H30H3Props,
    divDiv0Div1Link0LinkProps,
    sectionDiv0Div0ClassName,
    supportSection46s,
    supportSection46sItemWrapper,
    supportSection46sRenderer,
    supportSection46sLinkVisible,
    supportSection46sLinkRenderer,
    supportSection46sH3Visible,
    supportSection46sH3Renderer,
    supportSection46sLinkProps,
    supportSection46sH3Props,
}) => {
    return (
        <section className="journey-section-eight section wow fadeInUp" data-wow-duration={sectionDataWowDuration}>
            <div className="container">
                <div className={sectionDiv0Div0ClassName ?? "row g-5"}>
                    {renderCollectionNode(
                        supportSection46s,
                        (item: SupportSection46sItem) => (
                            <div className={item.divClassName ?? "col-xl-4 col-lg-6"} key={item.key}>
                                <div className={item.div0ClassName ?? "journey-item-eight"}>
                                    <div className={item.div0ClassName2 ?? "journey-icon"}>
                                        <i className={item.className} />
                                    </div>
                                    <div className={item.div1ClassName ?? "journey-content"}>
                                        {renderItemNode(supportSection46sH3Visible, supportSection46sH3Renderer, item, (
                                            <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof supportSection46sH3Props === "function" ? supportSection46sH3Props(item) : (supportSection46sH3Props ?? {}))} {...(typeof divDiv0Div1H30H3Props === "function" ? divDiv0Div1H30H3Props(item) : (divDiv0Div1H30H3Props ?? {}))}>{item.h30Text}</h3>
                                        ))}
                                        {renderItemNode(supportSection46sLinkVisible, supportSection46sLinkRenderer, item, (
                                            <SmartLink href={item.href ?? "all_routes.doctorAppointments"} {...(typeof supportSection46sLinkProps === "function" ? supportSection46sLinkProps(item) : (supportSection46sLinkProps ?? {}))} {...(typeof divDiv0Div1Link0LinkProps === "function" ? divDiv0Div1Link0LinkProps(item) : (divDiv0Div1Link0LinkProps ?? {}))}>
                                                {item.link0Text}
                                                <i className={item.i0ClassName ?? "isax isax-arrow-right-3"} />
                                                {" "}
                                            </SmartLink>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        ),
                        supportSection46sItemWrapper,
                        supportSection46sRenderer
                    )}
                </div>
            </div>
        </section>
    );
};

export default HomeEightSupportSectionGenerated;
